module.exports = __webpack_public_path__ + "img/GreekTechSarissophoroi2_ua.2dac0277.webp";